import { PRIVACY_CONTACT_EMAIL } from "./privacyContacts";

// Исполнитель — ИП, который предоставляет Relock: подвал всех страниц, политика, соглашение
// и «Тарифы» (их проверяет модерация платёжного сервиса). Имя — по-русски и латиницей.
export const SELLER = {
  name: {
    ru: "ИП Быков Алексей Николаевич",
    en: "Individual entrepreneur Alexey Nikolaevich Bykov",
  },
  inn: "560402163208",
  ogrnip: "326470400082561",
  email: PRIVACY_CONTACT_EMAIL,
  // Поддержка в Telegram — та же ссылка, что внизу бокового меню.
  supportUrl: "https://t.me/relockGG",
} as const;
